(function() { window.GUID_e5a83242_835f_4c4d_8a78_cd0fc76ab60c = { getGuid: function() { return "e5a83242-835f-4c4d-8a78-cd0fc76ab60c"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PictureSize;
        (function (PictureSize) {
            PictureSize[PictureSize["Small"] = 0] = "Small";
            PictureSize[PictureSize["Medium"] = 1] = "Medium";
            PictureSize[PictureSize["Large"] = 2] = "Large";
            PictureSize[PictureSize["Thumb"] = 3] = "Thumb";
        })(PictureSize = Enumeration.PictureSize || (Enumeration.PictureSize = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PictureSize.pre.js.map
